module.exports = __webpack_public_path__ + "img/bucana-front.7a30c79e.jpg";